import API from '../api';

export const getInterviewSkillOptions = ({ signal } = {}) =>
  API.get('/skills/skills/', { params: { page_size: 500 }, signal })
    .then((response) => response.data?.results || response.data || []);

export const getInterviewTemplateOptions = ({ signal } = {}) =>
  API.get('/skills/templates/', { params: { page_size: 500 }, signal })
    .then((response) => response.data?.results || response.data || []);

export const applyInterviewTemplate = (interviewUuid, templateUuid) =>
  API.post(`/interviews/interviews/${interviewUuid}/apply_template/`, {
    template: templateUuid,
  }).then((response) => response.data);
